import Vue from "vue";
import Router from "vue-router";

import Page from "./layout/Page.vue";
import Login from "./modules/login/router.js";
import Home from "./modules/home/router.js";
import Sys from "./modules/sys/router.js";
import Info from "./modules/info/router.js";
import Rclx from "./modules/rclx/router.js";
import Xypj from "./modules/xypj/router.js";
import Tk from "./modules/tk/router.js";
import Caiwu from "./modules/caiwu/router.js";
import Reg from "./modules/reg/router.js";
import Zyba from "./modules/zyba/router.js";
import PersonCenter from "./modules/person/router.js";


Vue.use(Router);

export default new Router({
  routes: [
    ...Login,
    {
      path: "/page",
      name: "Page",
      component: Page,
      children:[
          ...Home,
		  ...PersonCenter,
          ...Sys,
          ...Info,
          ...Rclx,
		  ...Xypj,
          ...Tk,
		  ...Zyba,
		  ...Reg,
		  ...Caiwu
      ]
    }

  ]
});
